export class WebAppInfo {
  public readonly appVersion = "1.5.23 (10)";

}
